import { createSvgIcon } from "@mui/material";

const EmailSendDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.5335C0 9.75145 9.55126 0.200195 21.3333 0.200195H58.6667C70.4487 0.200195 80 9.75146 80 21.5335V58.8669C80 70.6489 70.4487 80.2002 58.6667 80.2002H21.3333C9.55126 80.2002 0 70.6489 0 58.8669V21.5335Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M61.1671 61.1307H27.8963C24.4005 61.1307 21.6279 58.3581 21.6279 54.8623V31.2352C21.6279 27.8599 24.4005 24.9668 27.8963 24.9668H61.2877C64.663 24.9668 67.5561 27.7394 67.5561 31.2352V54.9828C67.4355 58.3581 64.663 61.1307 61.1671 61.1307Z"
      fill="#E8EEF2"
    />
    <path
      d="M15.8804 48.6679V25.6293C15.8804 24.7702 16.5768 24.0737 17.4359 24.0737C18.295 24.0737 18.9915 24.7702 18.9915 25.6293V48.6679C18.9915 51.7362 21.4788 54.2235 24.547 54.2235H41.8496C42.7086 54.2235 43.405 54.92 43.4051 55.779C43.4051 56.6381 42.7087 57.3346 41.8496 57.3346H24.547C19.7606 57.3346 15.8804 53.4544 15.8804 48.6679Z"
      fill="#B4C8D3"
    />
    <path
      d="M27.9185 41.3668C28.6479 40.9129 29.6074 41.1365 30.0613 41.8659C30.515 42.5953 30.2915 43.5545 29.5622 44.0083L18.7128 50.7587C17.9834 51.2125 17.0243 50.9894 16.5704 50.26C16.1165 49.5306 16.3401 48.5711 17.0695 48.1172L27.9185 41.3668Z"
      fill="#B4C8D3"
    />
    <path
      d="M61.936 41.1806V27.9792C61.936 24.9109 59.4487 22.4236 56.3804 22.4236H22.7133C20.7682 22.4236 19.1157 23.9916 18.975 25.9076L37.7789 38.1237L37.8895 38.1923C39.0176 38.8646 40.3281 38.8555 41.4516 38.1662L56.2298 25.9379C56.8917 25.3902 57.8722 25.4831 58.4199 26.145C58.9676 26.8069 58.8752 27.7874 58.2133 28.3351L43.354 40.6306C43.306 40.6703 43.2557 40.7072 43.2033 40.7409C41.0034 42.1551 38.2966 42.1551 36.0966 40.7409C36.0945 40.7395 36.0922 40.7379 36.0901 40.7365L17.1643 28.441C17.1591 28.4376 17.1542 28.434 17.1491 28.4306C16.5124 28.0061 15.8536 27.2185 15.8535 26.1723C15.8535 22.4201 18.9611 19.3125 22.7133 19.3125H56.3804C61.1669 19.3125 65.0471 23.1927 65.0471 27.9792V41.1806C65.047 42.0396 64.3506 42.7361 63.4915 42.7361C62.6325 42.7361 61.9361 42.0396 61.936 41.1806Z"
      fill="#B4C8D3"
    />
    <path
      d="M48.5929 54.519L62.5817 54.519C63.4408 54.519 64.1372 53.8226 64.1372 52.9635C64.1372 52.1044 63.4408 51.4079 62.5817 51.4079L48.5929 51.4079C47.7338 51.4079 47.0374 52.1044 47.0374 52.9635C47.0374 53.8226 47.7338 54.519 48.5929 54.519Z"
      fill="#00A866"
    />
    <path
      d="M66.2802 54.0052C66.8319 53.3945 66.8136 52.4522 66.2251 51.8637L59.8666 45.5052L59.8084 45.4496C59.1978 44.8981 58.2554 44.9167 57.6669 45.5052C57.0785 46.0937 57.0601 47.036 57.6118 47.6467L57.6669 47.7048L62.9256 52.9635L57.6669 58.2222C57.0595 58.8297 57.0595 59.8144 57.6669 60.4218C58.2744 61.0293 59.2591 61.0293 59.8666 60.4218L66.2251 54.0633L66.2802 54.0052Z"
      fill="#00A866"
    />
  </svg>,
  "EmailSendDialogIcon"
);

export default EmailSendDialogIcon;
